import api from "../../services/api";

const useActivityLog = () => {

    const find = async (params) => {
        const { data } = await api.request({
            url: `/showActivity`,
            method: 'POST',
            params
        });
        return data;
    }

    return {
        find
    }
}

export default useActivityLog;